import { WORDS } from "../constants/wordlist";

export const isWordInWordList = (word: string) => {
  return WORDS.includes(word.toLowerCase());
};

export const isWinningWord = (word: string) => {
  return solution === word;
};

export const getWordIndex = () => {
  // January 14, 2022 Game Epoch
  const epochMs = 1642136400000;
  const now = Date.now();
  const msInDay = 86400000;
  return Math.floor((now - epochMs) / msInDay);
};

export const getWordOfDay = () => {
  const index = getWordIndex();
  return WORDS[index].toUpperCase();
};

export const solution = getWordOfDay();
